// extracted by mini-css-extract-plugin
module.exports = {"timeline":"Timeline_timeline__3gVEU","entry":"Timeline_entry__1VcTK","marker":"Timeline_marker__34c2m","content":"Timeline_content__1inEA"};